import React, { Component } from "react";

import { Box, Checkbox, Column, Columns, Control, Field, Input, Title } from "@allxsmith/bestax-bulma";
import {Picker} from "../Utils/Picker";

class LicenceSection extends Component {
  render() {

    let additionalContacts = (this.props.rental.customer && this.props.rental.customer.id) ? this.props.rental.customer.additional_contacts : [];

    let additionContactObjects = additionalContacts && additionalContacts.length > 0 ? additionalContacts.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

    const onContactChange = e => {
      let driver = additionContactObjects[e.target.value]
      const toUpdate = {
        target: {
          name: e.target.name,
          value: driver
        }
      }
      this.props.onChange(toUpdate);
      // now handle changing all the licence information
      if(driver) {
        let otherDataToChange = {
          licence_number: driver.licence_number,
          ni_number: driver.ni_number,
          licence_type: driver.licence_type,
          licence_held: driver.licence_held,
          licence_expiry_date: driver.licence_expiry_date,
          licence_check_date: driver.licence_checked_date
        }
        this.props.triggerChange(otherDataToChange);
      }
    }

    return (
      <Box>
        <Title>Licence</Title>
        <Columns isMultiline>
          <Column>
            <Picker
              options={{results: additionalContacts}}
              label={"Licence Holder"}
              value={this.props.rental.driver}
              blank={true}
              name={"driver"}
              optionField={"name"}
              onChange={onContactChange}
            />
          </Column>
          <Column>
            <label className="label">Corporate Licence</label>
            <Checkbox
              checked={this.props.rental.corp_licence}
              onChange={this.props.onCheck}
              name={"corp_licence"}
            />
          </Column>
        </Columns>
        <Columns isMultiline>
          <Column>
            <Field>
              <label className="label">N.I. Number</label>
              <Control>
                <Input
                  type="text"
                  name="ni_number"
                  onChange={this.props.onChange}
                  value={this.props.rental.ni_number}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Licence Number</label>
              <Control>
                <Input
                  type="text"
                  name="licence_number"
                  onChange={this.props.onChange}
                  value={this.props.rental.licence_number}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Licence Type</label>
              <Control>
                <Input
                  type="text"
                  name="licence_type"
                  onChange={this.props.onChange}
                  value={this.props.rental.licence_type}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Licence Held (Years)</label>
              <Control>
                <Input
                  type="number"
                  name="licence_held"
                  onChange={this.props.onChange}
                  value={String(this.props.rental.licence_held)}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Licence Expiry Date</label>
              <Control>
                <Input
                  type="date"
                  name="licence_expiry_date"
                  onChange={this.props.onChange}
                  value={this.props.rental.licence_expiry_date}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">Licence Check Date</label>
              <Control>
                <Input
                  type="date"
                  name="licence_check_date"
                  onChange={this.props.onChange}
                  value={this.props.rental.licence_check_date}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">License Checked</label>
              <Control>
                <Checkbox
                  name="licence_checked"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.licence_checked}
                />
              </Control>
            </Field>
          </Column>
          <Column>
            <Field>
              <label className="label">License Copy Taken</label>
              <Control>
                <Checkbox
                  name="licence_copy_taken"
                  onChange={this.props.onCheck}
                  checked={this.props.rental.licence_copy_taken}
                />
              </Control>
            </Field>
          </Column>
        </Columns>
      </Box>
    );
  }
}

export default LicenceSection;
